import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';
import {useTranslation} from "react-i18next";

const BimiImportance = () => {
    const {t} = useTranslation();

    return (
        <Container className="py-5">
            <Row className="justify-content-center">
                <Col xs={12} md={10} lg={8}>
                    {/* Title */}
                    <h1 className="mb-4">{t("posts.bimiImportance.title")}</h1>

                    {/* Introduction */}
                    <p>
                        {t("posts.bimiImportance.sections.introduction")}
                    </p>

                    {/* What is BIMI? */}
                    <h2 className="mt-5">{t("posts.bimiImportance.sections.whatIsBimi.title")}</h2>
                    <p dangerouslySetInnerHTML={{__html: t("posts.bimiImportance.sections.whatIsBimi.descriptions.1")}}>
                    </p>
                    <ul>
                        <li>{t("posts.bimiImportance.sections.whatIsBimi.descriptions.2.1")}</li>
                        <li>{t("posts.bimiImportance.sections.whatIsBimi.descriptions.2.2")}</li>
                        <li>{t("posts.bimiImportance.sections.whatIsBimi.descriptions.2.3")}</li>
                    </ul>
                    <p>
                        {t("posts.bimiImportance.sections.whatIsBimi.descriptions.3")}
                    </p>

                    {/* Brand Recognition and Trust */}
                    <h2 className="mt-5">{t("posts.bimiImportance.sections.brandRecognition.title")}</h2>
                    <p>
                        {t("posts.bimiImportance.sections.brandRecognition.descriptions.1")}
                    </p>
                    <ul>
                        <li dangerouslySetInnerHTML={{__html: t("posts.bimiImportance.sections.brandRecognition.descriptions.2.1")}}></li>
                        <li dangerouslySetInnerHTML={{__html: t("posts.bimiImportance.sections.brandRecognition.descriptions.2.2")}}></li>
                    </ul>

                    {/* Enhanced Deliverability */}
                    <h2 className="mt-5">{t("posts.bimiImportance.sections.enhancedDeliverability.title")}</h2>
                    <p>
                        {t("posts.bimiImportance.sections.enhancedDeliverability.descriptions.1")}
                    </p>
                    <p>
                        {t("posts.bimiImportance.sections.enhancedDeliverability.descriptions.2")}                    </p>

                    {/* Prerequisites for BIMI */}
                    <h2 className="mt-5">{t("posts.bimiImportance.sections.prerequisitesForBimi.title")}</h2>
                    <p>
                        {t("posts.bimiImportance.sections.prerequisitesForBimi.descriptions.1")}
                    </p>
                    <ul>
                        <li dangerouslySetInnerHTML={{__html: t("posts.bimiImportance.sections.prerequisitesForBimi.descriptions.2.1")}}></li>
                        <li dangerouslySetInnerHTML={{__html: t("posts.bimiImportance.sections.prerequisitesForBimi.descriptions.2.2")}}></li>
                        <li dangerouslySetInnerHTML={{__html: t("posts.bimiImportance.sections.prerequisitesForBimi.descriptions.2.3")}}></li>
                        <li dangerouslySetInnerHTML={{__html: t("posts.bimiImportance.sections.prerequisitesForBimi.descriptions.2.4")}}></li>
                    </ul>
                    <p>
                        {t("posts.bimiImportance.sections.prerequisitesForBimi.descriptions.3")}
                    </p>

                    {/* Conclusion */}
                    <p className="mt-5"
                       dangerouslySetInnerHTML={{__html: t("posts.bimiImportance.sections.conclusion.descriptions.1")}}>
                    </p>
                    <p dangerouslySetInnerHTML={{__html: t("posts.bimiImportance.sections.conclusion.descriptions.2")}}>
                    </p>
                </Col>
            </Row>
        </Container>
    );
};

export default BimiImportance;
